import { render, staticRenderFns } from "./pix-title-loader.vue?vue&type=template&id=ded1df40&scoped=true&"
import script from "./pix-title-loader.vue?vue&type=script&lang=js&"
export * from "./pix-title-loader.vue?vue&type=script&lang=js&"
import style0 from "./pix-title-loader.vue?vue&type=style&index=0&id=ded1df40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded1df40",
  null
  
)

export default component.exports